import { render, staticRenderFns } from "./DashboardUserNumber.vue?vue&type=template&id=91988702&"
import script from "./DashboardUserNumber.vue?vue&type=script&lang=js&"
export * from "./DashboardUserNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports